var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.2222,
    y: 83.2222,
    width: 82.4444,
    height: 82.4444,
    rx: 41.2222,
    transform: "rotate(-180 83.2222 83.2222)",
    stroke: "#C8AA8E",
    strokeWidth: 1.55556
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28L56 56",
    stroke: "white",
    strokeWidth: 1.55556,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28L28 56",
    stroke: "white",
    strokeWidth: 1.55556,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/Close Button.0f75fa51f258082848b2094783216175.svg";
export { ForwardRef as ReactComponent };